module.exports = __webpack_public_path__ + "img/statusPanel-1.4fd037a8.png";